import { render, staticRenderFns } from "./CaseListItem.vue?vue&type=template&id=1f593da8&scoped=true&"
import script from "./CaseListItem.vue?vue&type=script&lang=js&"
export * from "./CaseListItem.vue?vue&type=script&lang=js&"
import style0 from "./CaseListItem.vue?vue&type=style&index=0&id=1f593da8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f593da8",
  null
  
)

export default component.exports